import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';

import { connect, useDispatch } from 'react-redux';

import BobPage from '../../../components/BobPage';
import TableContainer from './TableContainer';
import { isEmpty } from 'lodash';

import classes from './CompanyManagement.module.css';

import * as companyManagementAction from '../../../actions/companyManagementActions';
import SettingsContainer from './SettingsContainer';
import {handleNavBackNavEntities} from '../Navigation/NavigationHelper';
import { setPageTitle } from '../../../helpers/auth';
import * as bobActions from '../../../actions/bobActions';

const CompanyManagement = ({
    activeNavCompany,
    allCompanies,
    companies,
    currentUser,
    fetchNavSites,
    fetchNavEquipment,
    history,
    setActiveNavClient,
    setActiveNavEquipment,
    setActiveNavSite,
    setNavClient,
    setNavEquipment,
    setNavSite,
    targetNavCompany,
    fetchCompanies,
    ...props
}) => {
    const dispatch = useDispatch();

    const [companyCreate, setCompanyCreate] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);

    useEffect(() => {
        if (!isEmpty(activeNavCompany)) {
            if (companyCreate) {
                setPageTitle(activeNavCompany.name, 'New Company');
            } else {
                setPageTitle(activeNavCompany.name, 'Company Management');
            }
        }
    }, [activeNavCompany, companyCreate]);

    useEffect(() => {
        if (history.location.state && history.location.state.isManage) {
            const activeCompany = companies.find(company => company.company.id === activeNavCompany.id);
            if (activeCompany) {
                if (!selectedCompany) {
                    activeCompany.company.contractorTypeIds = activeCompany.contractorTypes.map(contractorType => contractorType.id);
                    setSelectedCompany(activeCompany.company);
                    setPageTitle(`K2A Core - ${activeCompany.company.name}`, 'Management');
                }
            }
        }
    }, [history.location.state]);

    const handleBackClick = () => {
        if (isAdmin()) {
            let state = { ...history.location.state };
            delete state.isManage;
            history.replace({ ...history.location, state });

            setCompanyCreate(false);
            setSelectedCompany(null);
        } else {
            if (history.location.state && history.location.state.returnUrl) {
                handleNavBackNavEntities(history.location.state, dispatch);
                history.push(history.location.state.returnUrl);
            } else {
                history.push(`/v2/dashboard/company?appId=ad356bf2-b9db-4bb5-922e-c3394b1a63e3&childId=ccb00d85-7b0c-44ba-bd0e-db216ef1ee46&company=${activeNavCompany.id}&parentId=ad356bf2-b9db-4bb5-922e-c3394b1a63e4`);
            }
        }
    };

    const isAdmin = () => {
        if (currentUser.isSuperUser) {
            return true;
        }

        const activeCompany = companies.find(company => company.company.id === activeNavCompany.id);
        if (activeCompany) {
            if (!selectedCompany) {
                activeCompany.company.contractorTypeIds = activeCompany.contractorTypes.map(contractorType => contractorType.id);
                setSelectedCompany(activeCompany.company);
            }
        }

        return false;
    };

    return (
        <BobPage>
            <div className={classes.CompanyPage}>
                <div className={classes.CompanyNamePanel}>
                    {activeNavCompany.name}
                </div>
                <div className={classes.HeaderPanel}>
                    {
                        selectedCompany || companyCreate ?
                            <span>
                                <span
                                    className={classes.BackIcon}
                                    aria-hidden="true"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() =>
                                        handleBackClick()
                                    }
                                >
                                    <i className="fas fa-chevron-left" />
                                </span>
                                {companyCreate ? 'New Company' : `${selectedCompany.name}`}
                            </span> : 'Company Management'
                    }
                </div>
                <div className={classes.DataPanel} />
                <div className={classes.TablePanel}>
                    {
                        currentUser.email && isAdmin() && !companyCreate && !selectedCompany
                        && !(history.location.state && history.location.state.isManage) ?
                            <TableContainer
                                companyCreate={companyCreate}
                                setCompanyCreate={setCompanyCreate}
                                setSelectedCompany={setSelectedCompany}
                            />
                            :
                            currentUser.isSuperUser !== null ?
                                selectedCompany || companyCreate ?
                                    <SettingsContainer
                                        companyCreate={companyCreate}
                                        handleBackClick={handleBackClick}
                                        selectedCompany={selectedCompany}
                                        setCompanyCreate={setCompanyCreate}
                                        setSelectedCompany={setSelectedCompany}
                                        currentUser={currentUser}
                                    />
                                    :
                                    null
                                :
                                null
                    }
                </div>
            </div>
        </BobPage>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
    companies:        state.core.companies,
    currentUser:      state.currentUser
});

const mapDispatchToProps = ({
    ...companyManagementAction,
    ...bobActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyManagement));
